//#region Auth
export const LOGIN = 'LOGIN';
export const VERIFY_CODE = 'VERIFY_CODE';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const NEW_PASSWORD = 'NEW_PASSWORD';
//#endregion Auth

//#region Customer
export const GET_CUSTOMER_LIST = 'GET_CUSTOMER_LIST';
export const CREATE_CUSTOMER = 'CREATE_CUSTOMER';
export const EDIT_CUSTOMER = 'EDIT_CUSTOMER';
export const GET_CUSTOMER_DETAIL = 'GET_CUSTOMER_DETAIL';
export const GET_SCHEDULE_LIST_BY_CUSTOMER = 'GET_SCHEDULE_LIST_BY_CUSTOMER';
export const IMPORT_CUSTOMER = 'IMPORT_CUSTOMER';
export const EXPORT_CUSTOMER = 'EXPORT_CUSTOMER';
export const SEND_TO_QUICK_BOOKS = 'SEND_TO_QUICK_BOOKS';
export const DELETE_CUSTOMER = 'DELETE_CUSTOMER';
//#endregion Customer

//#region Job
export const CREATE_JOB = 'CREATE_JOB';
export const GET_JOB_LIST = 'GET_JOB_LIST';
export const GET_JOB_DETAIL = 'GET_JOB_DETAIL';
export const GET_JOB_DETAIL_UPDATE = 'GET_JOB_DETAIL_UPDATE';
export const GET_JOB_LIST_BY_CUSTOMER = 'GET_JOB_LIST_BY_CUSTOMER';
export const GET_SCHEDULE_LIST_BY_JOB = 'GET_SCHEDULE_LIST_BY_JOB';
export const DELETE_JOB = 'DELETE_JOB';
export const UPDATE_JOB = 'UPDATE_JOB';
export const CHANGE_STATUS = 'CHANGE_STATUS';
//#endregion Job

//#region Employee
export const GET_EMPLOYEE_LIST = 'GET_EMPLOYEE_LIST';
export const CREATE_EMPLOYEE = 'CREATE_EMPLOYEE';
export const GET_EMPLOYEE_DETAIL = 'GET_EMPLOYEE_DETAIL';
export const DELETE_EMPLOYEE = 'DELETE_EMPLOYEE';
export const UPDATE_EMPLOYEE = 'UPDATE_EMPLOYEE';
export const UPDATE_STATUS_EMPLOYEE = 'UPDATE_STATUS_EMPLOYEE';
export const UPLOAD_FILE_EXCEL = 'UPLOAD_FILE_EXCEL';
export const GET_EMPLOYEE_REVIEW = 'GET_EMPLOYEE_REVIEW';
//#endregion Employee

//#region Document
export const UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT';
export const GET_DOCUMENT_LIST_BY_FOLDER = 'GET_DOCUMENT_LIST_BY_FOLDER';
export const EDIT_DOCUMENT = 'EDIT_DOCUMENT';
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';
//#endregion Document

//#region Folder
export const GET_FOLDER_LIST = 'GET_FOLDER_LIST';
export const CREATE_FOLDER = 'CREATE_FOLDER';
export const UPDATE_FOLDER = 'UPDATE_FOLDER';
export const DELETE_FOLDER = 'DELETE_FOLDER';
//#endregion Folder

//#region File
export const UPLOAD_MULTIPLE_FILE_AND_GET_LINK = 'UPLOAD_MULTIPLE_FILE_AND_GET_LINK';
export const GET_FILE_LIST = 'GET_FILE_LIST';
//#endregion File

//#region Contact
export const CREATE_CONTACT = 'CREATE_CONTACT';
export const GET_CONTACT_LIST = 'GET_CONTACT_LIST';
export const GET_DETAIL_CONTACT = 'GET_DETAIL_CONTACT';
export const UPDATE_CONTACT = 'UPDATE_CONTACT';
export const SEND_EMAIL = 'SEND_EMAIL';
export const CONVERT_TO_CUSTOMER = 'CONVERT_TO_CUSTOMER';
export const DELETE_CONTACT = 'DELETE_CONTACT';
//#endregion

//#region Schedule
export const CREATE_SCHEDULE = 'CREATE_SCHEDULE';
export const GET_SCHEDULE_LIST = 'GET_SCHEDULE_LIST';
export const GET_SCHEDULE_DASHBOARD_LIST = 'GET_SCHEDULE_DASHBOARD_LIST';
export const DELETE_SCHEDULE = 'DELETE_SCHEDULE';
export const GET_SCHEDULE_DETAIL = 'GET_SCHEDULE_DETAIL';
export const UPDATE_SCHEDULE = 'UPDATE_SCHEDULE';
//#endregion

//#region Notes
export const CREATE_NOTE_SCHEDULE = 'CREATE_NOTE_SCHEDULE';
export const GET_NOTE_SCHEDULE_LIST = 'GET_NOTE_SCHEDULE_LIST';
export const GET_LIST_NOTE = 'GET_LIST_NOTE';
export const CREATE_NOTE = 'CREATE_NOTE';
export const UPDATE_NOTE = 'UPDATE_NOTE';
export const DELETE_NOTE = 'DELETE_NOTE';
//#endregion Notes

//#region Activity
export const GET_ACTIVITY_LIST = 'GET_ACTIVITY_LIST';
//#endregion Activity

//#region User
export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
//#endregion User

//#region Task
export const CREATE_TASK = 'CREATE_TASK';
export const GET_TASK_LIST = 'GET_TASK_LIST';
export const DELETE_TASK = 'DELETE_TASK';
export const GET_TASK_DETAIL = 'GET_TASK_DETAIL';
export const UPDATE_TASK = 'UPDATE_TASK';
export const CHANGE_STATUS_TASK = 'CHANGE_STATUS_TASK';
export const CREATE_TASK_JOB = 'CREATE_TASK_JOB';
export const EDIT_TASK_JOB = 'EDIT_TASK_JOB';
//#endregion Task

//#region Service
export const CREATE_SERVICE = 'CREATE_SERVICE';
export const GET_SERVICE_DETAIL = 'GET_SERVICE_DETAIL';
export const GET_SERVICE_LIST = 'GET_SERVICE_LIST';
export const UPDATE_SERVICE = 'UPDATE_SERVICE';
export const DELETE_SERVICE = 'DELETE_SERVICE';
//#endregion Service

//#region Material
export const CREATE_MATERIAL = 'CREATE_MATERIAL';
export const GET_MATERIAL_LIST = 'GET_MATERIAL_LIST';
export const GET_MATERIAL_DETAIL = 'GET_MATERIAL_DETAIL';
export const DELETE_MATERIAL = 'DELETE_MATERIAL';
export const UPDATE_MATERIAL = 'UPDATE_MATERIAL';
//#endregion Material

//#region Price Book
export const GET_PRICE_BOOK_LIST = 'GET_PRICE_BOOK_LIST';
export const CREATE_PRICE_BOOK = 'CREATE_PRICE_BOOK';
export const GET_PRICE_BOOK_DETAIL = 'GET_PRICE_BOOK_DETAIL';
export const UPDATE_PRICE_BOOK = 'UPDATE_PRICE_BOOK';
export const DELETE_PRICE_BOOK = 'DELETE_PRICE_BOOK';
//#endregion Price Book

//#region Statistic
export const GET_STATISTIC_SUMMARY = 'GET_STATISTIC_SUMMARY';
//#endregion Statistic

//#region Price Book
export const GET_LIST_CONVERSATION = 'GET_LIST_CONVERSATION';
export const CREATE_NEW_MESSAGE = 'CREATE_NEW_MESSAGE';
export const CREATE_NEW_CONVERSATION = 'CREATE_NEW_CONVERSATION';
export const GET_LIST_MESSAGE = 'GET_LIST_MESSAGE';
//#endregion Price Book

//#region Estimate Template
export const CREATE_NEW_ESTIMATE_TEMPLATE = 'CREATE_NEW_ESTIMATE_TEMPLATE';
export const GET_LIST_ESTIMATE_TEMPLATE = 'GET_LIST_ESTIMATE_TEMPLATE';
export const DELETE_ESTIMATE_TEMPLATE = 'DELETE_ESTIMATE_TEMPLATE';
export const UPDATE_ESTIMATE_TEMPLATE = 'UPDATE_ESTIMATE_TEMPLATE';
export const GET_ESTIMATE_TEMPLATE_DETAILS = 'GET_ESTIMATE_TEMPLATE_DETAILS';
//#endregion Estimate Template

//#region Campaign
export const GET_LIST_CAMPAIGN = 'GET_LIST_CAMPAIGN';
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const GET_DETAIL_CAMPAIGN = 'GET_DETAIL_CAMPAIGN';
//#endregion Campaign

//#region Estimate
export const CREATE_ESTIMATE = 'CREATE_ESTIMATE';
export const GET_LIST_ESTIMATE = 'GET_LIST_ESTIMATE';
export const GET_ESTIMATE_DETAIL = 'GET_ESTIMATE_DETAIL';
export const UPDATE_ESTIMATE = 'UPDATE_ESTIMATE';
export const GET_ESTIMATE_SCHEDULE_LIST = 'GET_ESTIMATE_SCHEDULE_LIST';
export const GET_ESTIMATE_DETAIL_UPDATE = 'GET_ESTIMATE_DETAIL_UPDATE';
export const CONVERT_TO_JOB = 'CONVERT_TO_JOB';
export const DELETE_ESTIMATE = 'DELETE_ESTIMATE';
export const SEND_ESTIMATE = 'SEND_ESTIMATE';
export const CHANGE_STATUS_ESTIMATE = 'CHANGE_STATUS_ESTIMATE';
//#endregion Estimate

//#region Time Clock
export const GET_TIME_CLOCK_LIST = 'GET_TIME_CLOCK_LIST';
export const DELETE_TIME_CLOCK = 'DELETE_TIME_CLOCK';
export const GET_TIME_CLOCK_DETAILS = 'GET_TIME_CLOCK_DETAILS';
export const EXPORT_TIME_CLOCKS = 'EXPORT_TIME_CLOCKS';
export const GET_TIME_CLOCK_HOURS_WORKED = 'GET_TIME_CLOCK_HOURS_WORKED';
//#endregion Time Clock

//#region Notification
export const GET_LIST_NOTIFICATION = 'GET_LIST_NOTIFICATION';
export const READ_NOTIFICATION = 'READ_NOTIFICATION';
//#endregion Notification

//#region Category
export const GET_LIST_CATEGORY = 'GET_LIST_CATEGORY';
//#endregion Category

//#region Master Data
export const GET_LIST_MASTER_DATA = 'GET_LIST_MASTER_DATA';
//#endregion Master Data

//#region Invoice
export const GET_LIST_INVOICE = 'GET_LIST_INVOICE';
export const CREATE_INVOICE = 'CREATE_INVOICE';
export const GET_INVOICE_DETAILS = 'GET_INVOICE_DETAILS';
export const CHANGE_STATUS_INVOICE = 'CHANGE_STATUS_INVOICE';
export const SEND_INVOICE = 'SEND_INVOICE';
//#endregion Invoice

//#region QuicKBooks
export const GET_LIST_CUSTOMER_QUICK_BOOKS = 'GET_LIST_CUSTOMER_QUICK_BOOKS';
export const GET_AUTH_URL_QUICK_BOOKS = 'GET_AUTH_URL_QUICK_BOOKS';
export const DISCONNECT_QUICK_BOOKS = 'DISCONNECT_QUICK_BOOKS';
//#endregion QuicKBooks

//#region Report
export const GET_REPORT_SERVICE_VOLUME = 'GET_REPORT_SERVICE_VOLUME';
export const GET_REPORT_AVERAGE_JOB = 'GET_REPORT_AVERAGE_JOB';
export const GET_REPORT_PURCHASE_ORDER_TOTAL = 'GET_REPORT_PURCHASE_ORDER_TOTAL';
export const GET_REPORT_SALE_BY_CITY = 'GET_REPORT_SALE_BY_CITY';
export const GET_REPORT_JOB_DISTRIBUTION = 'GET_REPORT_JOB_DISTRIBUTION';
//#endregion Report

//#region PO
export const GET_PO_LIST = 'GET_PO_LIST';
export const DELETE_PO = 'DELETE_PO';
export const GET_PO_NUMBER = 'GET_PO_NUMBER';
export const CREATE_PO = 'CREATE_PO';
export const EDIT_PO = 'EDIT_PO';
//#endregion PO

//#region Vendor
export const GET_VENDOR_LIST = 'GET_VENDOR_LIST';
//#endregion Vendor

//#region Review
export const GET_REVIEW_LIST = 'GET_REVIEW_LIST';
export const CREATE_REVIEW = 'CREATE_REVIEW';
export const CREATE_REPLY = 'CREATE_REPLY';
//#endregion Review

//#region Google
export const GET_AUTH_URL_GOOGLE = 'GET_AUTH_URL_GOOGLE';
export const GET_TOKEN_GOOGLE = 'GET_TOKEN_GOOGLE';
export const CONNECT_GOOGLE = 'CONNECT_GOOGLE';
export const DISCONNECT_GOOGLE = 'DISCONNECT_GOOGLE';
export const GET_LIST_GOOGLE_GMAIL = 'GET_LIST_GOOGLE_GMAIL';
export const SEND_GOOGLE_GMAIL = 'SEND_GOOGLE_GMAIL';
//#endregion Google
